export const EditPrompts = ({ section, onUpdated, style = {} }) => {

  return (
    <div style={{ display: "flex", flexDirection: "column", ...style }}>
      Edit Prompts
    </div>
  )
}

export default EditPrompts;
